import { LifeRingTrigger } from 'components/ActionBar/LifeRing/LifeRingButton/LifeRingButton';
import { ActionButton, ButtonPanel } from 'components/secondaryMarket/shared/status';
import { PanelFooter, PanelHeader } from 'components/secondaryMarket/shared/status/Panel';
import { ConnectedHelpCenterButton } from 'components/shared/HelpCenter/HelpCenterButton';
import { FormattedMessage } from 'components/shared/Intl/FormattedMessage';
import { useToggleFeature } from 'hooks/useToggleFeature';
import { FC } from 'react';

import { useSPIntl } from '../../../../../hooks/useIntl';
import type { SecondaryMarketPostEventTabType } from '../../../../../state/workspaces/model';

export type RejectedAmendSidePanelProps = Readonly<{
  tabType: SecondaryMarketPostEventTabType;
  onReset: () => void;
  errorMessage?: string;
}>;
export const RejectedAmendSidePanel: FC<RejectedAmendSidePanelProps> = ({ tabType, onReset, errorMessage }) => {
  const { formatMessage } = useSPIntl();
  const helpCenterEnhancement = useToggleFeature('helpCenterEnhancement');
  return (
    <div className="d-flex flex-column h-100 justify-content-start overflow-y-auto">
      <PanelHeader color="danger" discreet className="justify-content-around align-items-start">
        <strong className="px-3">{formatMessage({ defaultMessage: errorMessage, id: errorMessage as any })}</strong>
      </PanelHeader>
      <PanelFooter color="danger" statusKey="secondaryMarket.sidePanel.label.appliedRejected" icon="cancel" />
      <div className="flex-grow-1" />
      <ButtonPanel>
        <div className="d-flex mt-auto mb-1 w-100">
          <ActionButton
            color="discreet-secondary"
            label="secondaryMarket.sidePanel.label.ok"
            onClick={onReset}
            className="w-50"
          />
          {helpCenterEnhancement ? (
            <div className="d-flex w-50">
              <ConnectedHelpCenterButton helpCenterId={RejectedAmendSidePanel.name} />
            </div>
          ) : (
            <LifeRingTrigger e2e="SecondaryPanelContactUs-button" className="d-flex w-50">
              <button type="button" className="btn btn-default btn-xl m-1 w-100">
                <FormattedMessage id="lifeRing.helpRequest" />
                <em className="icon icon-outlined ms-1">live_help</em>
              </button>
            </LifeRingTrigger>
          )}
        </div>
        <ActionButton
          color="discreet-secondary"
          label={
            tabType === 'live'
              ? 'secondaryMarket.sidePanel.live.label.returnToOrderModification'
              : 'secondaryMarket.sidePanel.cpOrder.label.returnToOrderModification'
          }
          disabled={false}
          onClick={onReset}
        />
      </ButtonPanel>
    </div>
  );
};
RejectedAmendSidePanel.displayName = 'RejectedAmendSidePanel';
